export default __webpack_public_path__ + "static/media/Logo.1cd1c876.svg";